import { MyInjector } from "@src/app/app.module";
import { PersonService } from "@src/app/pages/person-page/person.service";
import { FormConfig } from "@src/app/shared/form/FormConfig";
import { FieldSet, LAYOUT_OPTIONS } from "@src/app/shared/form/field-set/field-set.component";
import { FieldMaker } from "@src/app/shared/field/FieldMaker";
import { Person } from "@src/app/model/person";
import { FormTextComponent } from "@src/app/shared/form/form-text/form-text.component";
import { CurrentUserService } from "@src/app/modules/user/current-user.service";
import { ChatField } from "@src/app/shared/chat/chat-field";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmDialogService } from "@src/app/shared/dialogs/confirmDialog";
import { PickDialogComponent } from "@src/app/shared/dialogs/pick-dialog/pick-dialog.component";
import { uuid } from "@src/app/model/abstract-object";
import { ActionColor, ActionHolder, IFormAction } from "@src/app/shared/form/form.component";
import { ServiceRequest } from "@src/app/model/serviceRequest";
import { GridField } from "@src/app/shared/grid/grid-field";
import { of } from "rxjs";
import { concatMap, map } from "rxjs/operators";

export class AddFollowerAction implements IFormAction {
    name = $localize`Add Follower`;
    color: ActionColor = 'primary';
    show = true;
    icon = 'person_add';
    approvalNeeded = false;
    disabled = false;
    approvalText = '';
    tipText: string;
    sr: ServiceRequest;

    constructor(
        private chatField: ChatField,
        private mailAction: ActionHolder,
        private fromAgentTeam: boolean,
        private mergeGrid?: GridField)
    {
        if (fromAgentTeam) {
            this.name = $localize`Add Agent Follower`;
        } else {
            this.name = $localize`Add OMC Follower`;
        }
    }

    action() {
        const addFollower = new AddFollower(this.chatField);
        //addFollower.addPersonAsFollower(this.fromAgentTeam,this.mailAction, this.mergeGrid,this.sr)
        return addFollower.addPersonAsFollower(this.fromAgentTeam,this.sr)
    }

    //  setup(serviceRequest: ServiceRequest) {
    setup(sr: ServiceRequest) {
        this.sr = sr;
        this.show = true;
    }
}

/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
export class AddFollower {

    personSvc = MyInjector.instance.get(PersonService);
    currentUserSvc = MyInjector.instance.get(CurrentUserService);
    chatField: ChatField;
    dialog = MyInjector.instance.get(MatDialog);
    cds = MyInjector.instance.get(ConfirmDialogService);
    forceTeamId: uuid = null;

    config = new FormConfig({
        fieldSet: new FieldSet({
            fields: [
                FieldMaker.id(),
                FieldMaker.rev(),
                Person.getTitleField(),
                FormTextComponent.make('First Name', 'firstName'),
                FormTextComponent.make('Last Name', 'lastName'),
                FormTextComponent.make('User Name', 'user.name', { sendServer: false }),
            ],
            formLayout: LAYOUT_OPTIONS.singleCol,
        }),
        title: $localize`People`,
    });

    constructor(chatField: ChatField) {
        this.chatField = chatField;
    }

    getDialogData(addFromAgentTeam: boolean) {

        this.config.fieldSet.fields.push(FormTextComponent.make('Telephone', 'phone'),);
        this.config.fieldSet.fields.push(FormTextComponent.make('Email', 'email'));
        this.config.fieldSet.fields.push(FieldMaker.notes());            

        if (this.currentUserSvc.currentUser.inAgency && !addFromAgentTeam) {
            this.forceTeamId = this.chatField.chat.teamId
        } else if (addFromAgentTeam) {
            this.forceTeamId = this.currentUserSvc.currentTeam.primaryAgentId;
        }

        return {
            config: this.config,
            service: this.personSvc,
            showSearch: true,
            forceTeamId: this.forceTeamId,
        }
    }

    /*
        Called from action - will return SR, and that can be used to refresh actions adding the new follower...
    */
    addPersonAsFollower(addFromAgentTeam = false, sr?: ServiceRequest) {

        const dialogRef = this.dialog.open(PickDialogComponent, {data: this.getDialogData(addFromAgentTeam)});

        return dialogRef.afterClosed().pipe( concatMap(person => {
            if (!person) {
                return of (sr)
            } else if (!person.email) {
                this.cds.alert('Cannot add person', person.fullName + ' has no email address ');
                return of(sr)
            } else if (this.chatField.chat.followers.find(fw => ( fw.personUserId && (fw.personUserId === person.userId)))) {
                this.cds.alert('Cannot add ', person.fullName
                    + ' their email is already in the list ');
                return of(sr);
            } else {
                const pId = this.chatField.chat.parentId;

                return this.chatField.chat.service.follow(pId, person.userId, person.id, this.forceTeamId).pipe(map(f => {
                    if (f) {
                        sr.followers.push(f);
                    }
                    return sr;
                }))
            }
        }));
    }
}
